// src/components/BoardPack/pages/consolidate_boardpack/cover_page.jsx
import React from "react";
import mawgifLogo from "@/assets/img/images.png";
import footerLogo2 from "@/assets/img/ACI_Logo.svg.png";

const SIDEBAR_WIDTH = 224;
const TOP_SPACE = 56;
const BOTTOM_SPACE = 110;

const CoverPage = ({
  isSidebar = true,
  isFooter = true,
  isExporting = false,
  page = null,
  year = null,
  month = null,
}) => {
  return (
    <>
      <div className="relative w-full overflow-hidden bg-[#006fc0]" style={{ height: 720 }}>
        {isSidebar && (
          <div
            className="absolute left-0 top-0 h-full bg-white flex items-center justify-center"
            style={{ width: SIDEBAR_WIDTH, zIndex: 5 }}
          >
            <img src={mawgifLogo} alt="Mawgif Logo" className="w-36 object-contain" />
          </div>
        )}

        <div
          className="absolute flex items-center justify-center"
          style={{
            left: isSidebar ? SIDEBAR_WIDTH : 0,
            right: 0,
            top: TOP_SPACE,
            bottom: BOTTOM_SPACE,
          }}
        >
          <div className="w-full h-full flex items-center justify-center">
            <div className="flex flex-col items-center justify-center gap-2">
              <span className="text-[48px] text-white whitespace-nowrap">{page?.title}</span>
              <span className="text-[40px] font-semibold text-white !border py-1 px-18 whitespace-nowrap">
                {month} - {year}
              </span>
            </div>
          </div>
        </div>

        <div
          className="absolute left-1/2 -translate-x-1/2 flex items-center"
          style={{ bottom: 8, zIndex: 10 }}
        >
          <span className="text-sm font-medium text-gray-600 px-3 py-0">{page?.page_no}</span>
        </div>

        {isFooter && (
          <div
            className="absolute right-1 flex gap-4 items-center bg-white p-2"
            style={{ bottom: 8, zIndex: 10 }}
          >
            <img src={footerLogo2} alt="Footer Logo 2" className="h-14 object-contain" />
          </div>
        )}
      </div>
    </>
  );
};

export default CoverPage;
